module.exports = __webpack_public_path__ + "img/79.9ce4ed57.png";